import { Button, Intent } from "@blueprintjs/core";
import { NiraDialog } from "components/common/NiraDialog";
import { ProjectPickerTable } from "../ScenarioBuilder/ProjectPickerTable";
import {
    BulkScenarioAssumptions,
    BulkScenarioDraft,
    bulkScenarioNotices
} from "./bulkScenarioDrafts";
import { BulkScenarioNoticeBanners } from "./BulkScenarioNoticeBanners";
import css from "./BulkScenarioSensitivitiesEditor.module.scss";

const SENSITIVITIES_EDITOR_EYEBROW = "Adjust sensitivities";

/** Edit which projects one uploaded scenario includes, excludes or downsizes. */
export const BulkScenarioSensitivitiesEditor: React.FC<{
    readonly draft: BulkScenarioDraft;
    readonly onlyExclusionSupported: boolean;
    readonly onUpdateAssumptions: (
        patch: Partial<BulkScenarioAssumptions>
    ) => void;
    readonly isErisWarningDismissed: boolean;
    readonly setIsErisWarningDismissed: (dismissed: boolean) => void;
    readonly onClose: () => void;
}> = ({
    draft,
    onlyExclusionSupported,
    onUpdateAssumptions,
    isErisWarningDismissed,
    setIsErisWarningDismissed,
    onClose
}) => {
    const notices = bulkScenarioNotices(
        draft.uploadNotes,
        onlyExclusionSupported
    );

    return (
        <NiraDialog
            isOpen
            onClose={onClose}
            eyebrow={SENSITIVITIES_EDITOR_EYEBROW}
            title={draft.title}
            className={css["BulkScenarioSensitivitiesEditor"]}
            bodyClassName={css["BulkScenarioSensitivitiesEditor-body"]}
            footerActions={
                <Button
                    text="Done"
                    intent={Intent.PRIMARY}
                    onClick={onClose}
                    size="large"
                />
            }
        >
            <div className={css["BulkScenarioSensitivitiesEditor-content"]}>
                <BulkScenarioNoticeBanners notices={notices} />
                <ProjectPickerTable
                    projectSizeAssumptions={draft.projectSizeAssumptions}
                    setProjectSizeAssumptions={(projectSizeAssumptions) =>
                        onUpdateAssumptions({ projectSizeAssumptions })
                    }
                    includedSpeculativeProjectIds={
                        draft.includedSpeculativeProjectIds
                    }
                    setIncludedSpeculativeProjectIds={(
                        includedSpeculativeProjectIds
                    ) => onUpdateAssumptions({ includedSpeculativeProjectIds })}
                    isErisWarningDismissed={isErisWarningDismissed}
                    setIsErisWarningDismissed={setIsErisWarningDismissed}
                />
            </div>
        </NiraDialog>
    );
};
